export interface ProgramFormGridProps {
    className?: string;
    style?: React.CSSProperties;
}

export enum ProgramFormGridNames {
    COMPANY = "company",
    NAME = "name",
    DESCRIPTION = "description",
    LOGO = "logo",
    URL = "url",
    MIN_AMOUNT = "minAmount",
    MAX_AMOUNT = "maxAmount",
    APPROVER = "approver.name",
    ADMIN_NAME = "admin.name",
    ADMIN_EMAIL = "admin.email",
    ADMIN_PHONE = "admin.phone",
}
